import axios from "axios";
import jwtDecode from "jwt-decode";
import config from "../../config";

class JwtUtils {
  getEmail() {
    return jwtDecode(localStorage.token).sub;
  }

  getUUID() {
    return jwtDecode(localStorage.token).uuid;
  }
  getName() {
    if (!localStorage.token) {
      return null;
    }
    return jwtDecode(localStorage.token)?.first_name;
  }

  getUUID() {
    if (!localStorage.token) {
      return null;
    }
    return jwtDecode(localStorage.token).uuid;
  }

  getProfilePictureUrl() {
    if (!localStorage.token) {
      return null;
    }
    return jwtDecode(localStorage.token).picture_url;
  }

  getAccessToken() {
    if (!localStorage.token) {
      return null;
    }
    return jwtDecode(localStorage.token).access_token;
  }

  isActif() {
    if (localStorage.token) {
      let decoded = jwtDecode(localStorage.token);
      return decoded?.isActif;
    }
    return false;
  }

  isTokenValidAndNotExpired() {
    try {
      let decoded = jwtDecode(localStorage.token, config.jwtSecret);
      if (Date.now() >= decoded.exp * 1000) {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  isExpired(token = localStorage.token) {
    if(!token) {
      return true;
    }
    let decoded = jwtDecode(token);
    if (Date.now() >= decoded.exp * 1000) {
      return true;
    }
    return false;
  }

  hasAnyRole(rolesIn) {
    if (rolesIn.length === 0) {
      return true;
    }
    if (!localStorage.token) {
      return false;
    }
    let currentRoles = jwtDecode(localStorage.token)?.roles ?? [];
    localStorage.setItem("roles", currentRoles);
    const found = rolesIn.some((r) => currentRoles.indexOf(r) >= 0);
    return found;
  }

  logOutWithoutRefresh() {
    localStorage.token && localStorage.removeItem("token");
  }

  logOut() {
    if (localStorage.token) {
      localStorage.removeItem("token");
      window.location.reload();
    }
  }
}

export default new JwtUtils();
